import { render, staticRenderFns } from "./UserNotificationsDialogTabUpdates.vue?vue&type=template&id=63a5fe4e&scoped=true&"
import script from "./UserNotificationsDialogTabUpdates.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsDialogTabUpdates.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsDialogTabUpdates.vue?vue&type=style&index=0&id=63a5fe4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5fe4e",
  null
  
)

export default component.exports